module.exports = __webpack_public_path__ + "img/glassTravelingShowroomIcon.22f51013.jpg";